
const homepage = {
  // Hero section
  'hero.headline': 'Trading de Elite. Ahora Accesible para Todos.',
  'hero.subheadline': 'Estrategias de inversión profesionales una vez reservadas para instituciones — ahora disponibles para inversores minoristas a través de The Club',
  'hero.cta.join': 'Únete a The Club',
  'hero.cta.track': 'Seguir Nuestro Rendimiento',
  
  // What is The Club section
  'whatIs.header': '¿Qué es The Club?',
  'whatIs.subtitle': 'Trading Profesional, Redefinido para Ti',
  'whatIs.copy': 'En The Club, estamos remodelando el panorama financiero. Nuestra misión es simple: hacer accesibles las estrategias de trading de élite a nivel institucional para inversores minoristas — con transparencia, rendimiento y confianza en el núcleo. Ofrecer un modelo de negocio sostenible y a largo plazo que permita a las personas ordinarias participar en lo que una vez fue un mundo financiero exclusivo. Estamos aquí para democratizar el acceso a la libertad financiera — un inversor a la vez.',
  'whatIs.cta': 'Conoce al Equipo de The Club',
  
  // Why Join section
  'whyJoin.header': '¿Por qué unirse a The Club?',
  'whyJoin.subtitle': 'Inversión Inteligente, Simple y Poderosa',
  'whyJoin.copy': 'Nuestra plataforma te permite hacer crecer tu riqueza con confianza, guiado por expertos de primer nivel que manejan tu cartera.',
  'whyJoin.feature1.title': 'Comienza con solo $500',
  'whyJoin.feature1.desc': 'Sin barreras, sin límites — escala según tus términos',
  'whyJoin.feature2.title': 'Rendimiento Transparente',
  'whyJoin.feature2.desc': 'Acceso en tiempo real a las métricas de tu cartera',
  'whyJoin.feature3.title': 'Gestión Profesional de Riesgos',
  'whyJoin.feature3.desc': 'Estrategias para proteger y hacer crecer tu capital',
  'whyJoin.feature4.title': 'Soporte Global',
  'whyJoin.feature4.desc': 'Nuestro equipo está aquí — en tu idioma, en tu región',
  'whyJoin.cta': 'Invertir Ahora',
  
  // Trusted Broker section
  'broker.header': 'Bróker de Confianza',
  'broker.subtitle': 'Tu Capital Merece un Hogar Seguro',
  'broker.copy': 'La seguridad y transparencia importan. Por eso trabajamos exclusivamente con Radex Markets, un bróker regulado con licencia de la Autoridad de Servicios Financieros de Seychelles (FSA). Radex prioriza la protección del cliente implementando robustos protocolos de seguridad para salvaguardar tanto los fondos de los clientes como los datos personales. Ofrece tecnología de vanguardia y un entorno de trading competitivo diseñado para satisfacer las necesidades de los traders modernos.',
  'broker.cta': 'Aprende Más Sobre Nuestro Bróker',
  'broker.badge1': 'Procesamiento Seguro',
  'broker.badge2': 'Regulado por FSA',
  'broker.badge3': 'Seguridad de Fondos',
  'broker.badge4': 'Operaciones Transparentes',
  
  // Meet Traders section
  'traders.header': 'Conoce a Nuestros Traders',
  'traders.subtitle': 'Experiencia Real. Estrategias Probadas.',
  'traders.copy': 'Nuestro equipo de trading aporta más de 16 años de experiencia desarrollando estrategias algorítmicas institucionales desde 2009. Con un profundo entendimiento de los mercados globales, saben cómo adaptarse y rendir — sin importar las condiciones. Algunos de nuestros profesionales incluso han estado entre los 5 mejores en el Reino Unido en plataformas como Pelican Asset Management. Con un enfoque implacable en bajas pérdidas y estricto control de riesgos, ahora están accesibles para ti para entregar resultados.',
  'traders.stats.experience': '16+',
  'traders.stats.experienceLabel': 'Años de Experiencia',
  'traders.stats.rank': 'Top 5',
  'traders.stats.rankLabel': 'Ranking de Trading en Reino Unido',
  'traders.stats.since': 'Desde 2009',
  'traders.stats.sinceLabel': 'Desarrollo de Estrategias',
  'traders.approach.algorithmic.title': 'Enfoque Algorítmico',
  'traders.approach.algorithmic.point1': 'Toma de decisiones basada en datos',
  'traders.approach.algorithmic.point2': 'Estrategias probadas desde 2009',
  'traders.approach.algorithmic.point3': 'Parámetros de gestión de riesgos',
  'traders.approach.risk.title': 'Control de Riesgos',
  'traders.approach.risk.point1': 'Enfoque en bajas pérdidas',
  'traders.approach.risk.point2': 'Reglas estrictas de tamaño de posición',
  'traders.approach.risk.point3': 'Enfoque adaptativo del mercado',
  
  // Performance section
  'performance.header': 'Rendimiento de The Club',
  'performance.subtitle': 'Ve a Nuestros Traders en Acción',
  'performance.recentPerformance': 'Rendimiento Reciente',
  'performance.monthlyPerformance': 'Rendimiento Mensual',
  'performance.yearlyPerformance': 'Proyección Anual',
  'performance.maxDrawdown': 'Pérdida Máxima',
  'performance.winRate': 'Tasa de Ganancia',
  'performance.cta': 'Sigue Institutional Strategy en FX Blue',
  'performance.tagline': 'Rendimiento Máximo. Pérdida Mínima. 100% Transparencia.',
  'performance.myfxbooktext': 'Rendimiento como ningún otro, validado a través de FX Blue',
  'performance.institutional': 'Estrategia Institucional',
  'performance.spartanAi': 'Spartan AI',
  'performance.ctaSpartan': 'Sigue Spartan AI en Myfxbook',
  'performance.myfxbookTextSpartan': 'Rendimiento validado a través de Myfxbook',
  'performance.recentPerformanceInstitutional': 'Rendimiento de Institutional Strategy',
  'performance.recentPerformanceSpartan': 'Rendimiento de Spartan AI',
  'performance.strategiesCta': 'Conoce Más Sobre Nuestras Estrategias',
  
  // How it works section
  'howItWorks.header': 'Cómo Funciona',
  'howItWorks.subtitle': 'Reglas Simples. Recompensas Claras.',
  'howItWorks.feature1.title': 'Únete con solo $500',
  'howItWorks.feature1.desc': 'Comienza pequeño, escala en cualquier momento — sin límites máximos',
  'howItWorks.feature2.title': 'Sin Cuota de Membresía',
  'howItWorks.feature2.desc': 'Por tiempo limitado, la tarifa del 20% ha sido eliminada. Invierte con TheClub y empieza a ganar desde el primer día',
  'howItWorks.feature3.title': 'Incentivos Alineados',
  'howItWorks.feature3.desc': 'Una comisión de rendimiento del 50% — solo ganamos cuando tú ganas',
  'howItWorks.feature4.title': 'Retira en cualquier momento',
  'howItWorks.feature4.desc': 'Acceso completo al capital y ganancias — sin períodos de bloqueo',
  'howItWorks.feature5.title': 'Métodos de Depósito y Retiro',
  'howItWorks.feature5.desc': 'Visa, Mastercard, transferencia bancaria y cripto — rápido y flexible',
  'howItWorks.feature6.title': 'Cumplimiento KYC y AML',
  'howItWorks.feature6.desc': 'Tu seguridad y confianza regulatoria son nuestras prioridades',
  'howItWorks.cta': 'Únete a The Club',
  'howItWorks.calculator.title': 'Ve Tu Potencial de Crecimiento Con Interés Compuesto',
  'howItWorks.calculator.results': 'Resultados:',
  'howItWorks.calculator.totalInvestment': 'Inversión Total ($)',
  'howItWorks.calculator.investment': 'Inversión ($)',
  'howItWorks.calculator.membership': 'Cuota de Membresía ($)',
  'howItWorks.calculator.monthlyRate': 'Tasa de Interés Mensual (%)',
  'howItWorks.calculator.fiftymonthlyRate': '50% Tasa de Interés Mensual (%)',
  'howItWorks.calculator.variationRate': 'Tasa de Variación Mensual (%)',
  'howItWorks.calculator.years': 'Tiempo de Inversión (Años)',
  'howItWorks.calculator.calculate': 'Calcular',
'howItWorks.calculator.simpleInvestment': 'Valor futuro con retiro mensual',
'howItWorks.calculator.compoundInvestment': 'Valor futuro con interés compuesto',
'howItWorks.calculator.difference': 'Diferencia',
  'howItWorks.calculator.monthAbbr': 'M',
  'howItWorks.calculator.yearAbbr': 'A',
  'howItWorks.calculator.month': 'Mes',
  'howItWorks.calculator.year': 'Año',
  
  // Team section
  'team.header': 'Conoce a Nuestro Equipo',
  'team.subtitle': 'The Club es Impulsado por Visionarios',
  'team.text': 'Conoce las mentes que dan forma a la misión de The Club y fomentan la libertad financiera global a través de la transparencia, integridad y alto rendimiento — haciendo la inversión accesible para todos.',
  'team.member1': 'Gianluca N. – Director de Desarrollo \nde Nuevos Mercados',
  'team.member2': 'Samuel N. – Director de Mercadeo',
  'team.member3': 'Marco M. – Consultor de Corretaje\n(Representante de Italia \nen Radex Markets)',
  'team.member4': 'Lloyd S. – Director de Trading',
  'team.member5': 'Horacio A. – Consultor \nEjecutivo de Tecnología',
  
  // Global Presence section
  'global.header': 'Presencia Global',
  'global.subtitle': 'Caras Locales. Alcance Global.',
  'global.text': 'Ya sea que estés en Italia, Alemania, Medio Oriente o América Latina, estamos aquí con soporte local — en tu idioma y en tu zona horaria.',
  'global.contact1': 'Germano M. – Representante Del Idioma Italiano',
  'global.contact2': 'Manuel G. – Representante Del Idioma Alemán',
  'global.contact3': 'Horacio A. – Representante Del Idioma Español',
  'global.contact4': 'Aisha R. – Representante Del Idioma Inglés',
  'global.contact5': 'XXX XXXX – Representante De Los Idiomas Francés Y Árabe',
  'global.tagline': '¿Quieres hacer crecer tu propia comunidad con The Club? Habla directamente con uno de nuestros representantes.',
  
  // Referral section
  'referral.header': 'Programa de Referidos',
  'referral.subtitle': 'Gana Mientras Haces Crecer Tu Comunidad',
  'referral.text': 'Comparte la Oportunidad. Construye Tus Ingresos.',
  'referral.copy.default': 'Como socio de The Club, no solo puedes ganar con tus inversiones, sino también ayudar a otros a hacer crecer sus ingresos. Nuestro plan de compensación de 10 niveles te permite construir ingresos residuales a largo plazo — con pagos de comisiones programados para el día 10 de cada mes.',
  'referral.copy.alternate': 'Como socio de The Club, no solo puedes ganar con tus inversiones, sino también ayudar a otros a hacer crecer sus ingresos. Nuestro plan de compensación de 5 niveles te permite construir ingresos residuales a largo plazo — con pagos de comisiones programados para el día 10 de cada mes.',
  'referral.table.level': 'Nivel',
  'referral.table.commission': 'Comisión',
  'referral.table.levelNumber': 'Nivel {level}',
  'referral.structure.title': 'Estructura de Niveles',
  'referral.commission.title': 'Plan de Compensación - ¡Crea Tus Ingresos Pasivos!',
  'referral.commission.description.default': 'El plan de compensación paga hasta el 20% (combinado) en los primeros 10 niveles de profundidad basado en las ganancias generadas por los clientes de forma mensual. Esto le da a cada afiliado la oportunidad de ganar un ingreso mensual real y creciente gracias al efecto del interés compuesto, que permite a cada afiliado ver crecer su cartera de clientes con el tiempo, respaldado por el alto rendimiento de nuestras estrategias de trading.',
  'referral.commission.description.alternate': 'El plan de compensación paga hasta el 12% (combinado) en los primeros 5 niveles de profundidad basado en las ganancias generadas por los clientes de forma mensual. Esto le da a cada afiliado la oportunidad de ganar un ingreso mensual real y creciente gracias al efecto del interés compuesto, que permite a cada afiliado ver crecer su cartera de clientes con el tiempo, respaldado por el alto rendimiento de nuestras estrategias de trading.',
  'referral.example.title': 'Escenario de Ejemplo',
  'referral.example.text': 'Si refiere a 3 personas que cada una invierte $1,000, y cada una de ellas refiere a 2 personas más, ganas comisiones de las 9 personas en tu comunidad — creando un poderoso flujo de ingresos pasivos.',
  
  // New ReferralSection keys
  'referral.you': 'Tú',
  'referral.level1Commission': 'Nivel 1: 5% Comisión',
  'referral.directReferral': 'Referido Directo',
  'referral.levels2to4Commission': 'Niveles 2-4: 3% Comisión',
  'referral.levels5to6Commission': 'Niveles 5-6: 2% Comisión Cada Uno',
  'referral.level7Commission': 'Nivel 7: 1%',
  'referral.level8Commission': 'Nivel 8: 0,5%',
  'referral.level9Commission': 'Nivel 9: 0,3%',
  'referral.level10Commission': 'Nivel 10: 0,2%',
  'referral.communityExpands': 'Tu comunidad se expande más profundo, ganándote comisiones hasta {maxLevels} niveles',
  'referral.earnCommissions.default': 'El plan de compensación se basa en una estructura UNILEVEL que paga hasta 10 niveles de profundidad. Nuestra estructura te recompensa por construir una comunidad fuerte.',
  'referral.earnCommissions.alternate': 'El plan de compensación se basa en una estructura UNILEVEL que paga hasta 5 niveles de profundidad. Nuestra estructura te recompensa por construir una comunidad fuerte.',
  'referral.levelSuffix': 'Nivel',
  
  // Events section
  'events.header': 'Eventos y Comunidad',
  'events.subtitle': 'Un Club que Conecta',
  'events.text': 'Únete a Seminarios Web, conoce a otros inversores y sé parte de algo más grande. Ve lo que está pasando — en línea y en persona.',
  'events.event1': 'Eventos Próximamente',
  'events.event2': 'Eventos Próximamente',
  'events.event3': 'Eventos Próximamente',
  'events.communityHighlights': 'Destacados de la Comunidad',
  'events.weeklyStrategySessions': 'Sesiones de Estrategia Semanales',
  'events.weeklyStrategySessionsDesc': 'Únete a nuestros expertos analizando oportunidades del mercado',
  'events.investorInterviews': 'Entrevistas a Inversores',
  'events.investorInterviewsDesc': 'Escucha historias de éxito de nuestra comunidad en crecimiento',
  'events.educationalResources': 'Recursos Educativos',
  'events.tradingFundamentals': 'Fundamentos de Trading',
  'events.tradingFundamentalsDesc': 'Guías gratuitas para entender el trading',
  'events.expertWebinars': 'Seminarios Web con Expertos',
  'events.expertWebinarsDesc': 'Temas avanzados para usuarios experimentados',
  
  // Connect section
  'connect.header': 'Mantente Conectado',
  'connect.subtitle': 'Mantengámonos en Contacto',
  'connect.whatsapp': 'Contáctanos vía WhatsApp',
  'connect.language.english': 'English',
  'connect.language.italian': 'Italiano',
  'connect.language.spanish': 'Español',
  'connect.language.german': 'Deutsch',
  'connect.language.croatian': 'Hrvatski',
  'connect.language.turkish': 'Türkçe',
  'connect.language.french': 'Français',
  'connect.language.arabic': 'العربية',
    
  // Footer section
  'footer.rights': 'Todos los derechos reservados.',
  'footer.terms': 'Términos de Servicio',
  'footer.privacy': 'Política de Privacidad',
  'footer.cookies': 'Cookies',
  'footer.contactMe': 'Contáctame',
  
  // Strategies page
  // 'strategies.heroSubtitle': 'Dos Estrategias. Una Visión. Máxima Protección y Crecimiento.',
  'strategies.pageTitle': 'Estrategias de TheClub',
  'strategies.heroSubtitle': 'Una Visión. Máxima Protección y Crecimiento.',
  'strategies.learnMore': 'Saber más',
  'strategies.showLess': 'Mostrar menos',

  // Institutional Strategy
  'strategies.institutional.tagline': 'Precisión. Estabilidad. Protección de Nivel Institucional.',
  'strategies.institutional.highlight1': '16 Años de Experiencia',
  'strategies.institutional.highlight1Desc': 'Traders institucionales británicos con experiencia en hedge funds y Deutsche Bank',
  'strategies.institutional.highlight2': 'Enfoque en Gold y GU',
  'strategies.institutional.highlight2Desc': 'Algoritmos de media/alta frecuencia en Gold y Libra/Dólar',
  'strategies.institutional.highlight3': 'Objetivo Mensual 5–6%',
  'strategies.institutional.highlight3Desc': 'Rendimientos consistentes con un promedio del 35–40% anual',
  'strategies.institutional.highlight4': 'Riesgo Controlado',
  'strategies.institutional.highlight4Desc': 'Enfoque conservador priorizando la preservación del capital',
  'strategies.institutional.description': 'Es una estrategia gestionada directamente por nuestros traders institucionales británicos, un grupo de trabajo que lleva operando en los mercados financieros durante 16 años. Han trabajado con uno de los hedge funds más importantes del Reino Unido y con Deutsche Bank. Se especializan en la creación y actualización continua de algoritmos que operan a media/alta frecuencia principalmente en Gold y GU (Libra/Dólar). Es una estrategia que busca obtener un promedio del 5–6% mensual, como ya se logró en el primer año con The Club, manteniendo un riesgo relativamente contenido para proporcionar al cliente un promedio de alrededor del 35–40% anual.',

  // Spartan AI Strategy
  'strategies.spartanAi.tagline': 'Agresiva. Inteligente. Rendimiento de Nivel Spartan.',
  'strategies.spartanAi.highlight1': 'Impulsada por AI',
  'strategies.spartanAi.highlight1Desc': 'Inteligencia artificial continuamente actualizada por traders italianos',
  'strategies.spartanAi.highlight2': 'Gold Intradía',
  'strategies.spartanAi.highlight2Desc': 'Estrategia semi-manual que combina operaciones de AI con trades manuales',
  'strategies.spartanAi.highlight3': 'Mayor Potencial de Beneficio',
  'strategies.spartanAi.highlight3Desc': 'Enfoque más agresivo que genera rendimientos superiores',
  'strategies.spartanAi.highlight4': '20% Equity Stop',
  'strategies.spartanAi.highlight4Desc': 'Protección máxima de pérdida cubierta por los beneficios de Institutional Strategy',
  'strategies.spartanAi.description': 'Es una inteligencia artificial creada y continuamente actualizada por nuestro grupo de traders italianos que llevan trabajando profesionalmente en el mundo del trading durante 6 años con excelentes resultados. Es una estrategia más agresiva que opera de forma semi-manual: los propios traders operan combinando las operaciones de la AI con sus propios trades manuales. Opera intradía exclusivamente en Gold. Es una estrategia que tiende a generar beneficios mucho más altos pero al mismo tiempo tiene un equity stop del 20%. Esto significa que el cliente nunca podrá perder más del 20% del capital invertido en Spartan AI; este capital está cubierto por la Institutional Strategy con sus beneficios en caso de que, una vez al año, se alcance este equity stop.',

  // Strategy Bond (50/50)
  'strategies.bond.title': 'Más Fuertes Juntos: El Enfoque 50/50',
  'strategies.bond.description': 'Cada depósito se divide estratégicamente 50/50 entre ambas estrategias. La Institutional Strategy proporciona una base estable y conservadora que protege tu capital, mientras que Spartan AI ofrece un potencial de crecimiento agresivo. En el raro caso de que Spartan AI alcance su equity stop del 20%, los beneficios constantes de la Institutional Strategy sirven como red de seguridad — asegurando que tu inversión general permanezca protegida y en crecimiento.',
  'strategies.bond.benefit1': 'Máxima Protección',
  'strategies.bond.benefit1Desc': 'Los beneficios de Institutional Strategy protegen contra los equity stops de Spartan AI',
  'strategies.bond.benefit2': 'Diversificación Inteligente',
  'strategies.bond.benefit2Desc': 'Dos enfoques distintos reducen el riesgo general del portafolio',
  'strategies.bond.benefit3': 'Crecimiento Optimizado',
  'strategies.bond.benefit3Desc': 'Estabilidad conservadora se encuentra con potencial de beneficio agresivo',

  // Floating button
  'floatingButton.embassador.title': 'Conviértete en Embajador de The Club',
  'floatingButton.embassador.text': 'Únete a nuestro programa de referidos y gana comisiones fantásticas mientras ayudas a otros a alcanzar la libertad financiera. ¡Contáctanos por WhatsApp para comenzar tu camino como embajador de The Club hoy mismo!',
  'floatingButton.embassador.button': 'Conviértete en Embajador de The Club',
  'floatingButton.embassador.contact': 'Conéctate con un Representante',
  'floatingButton.embassador.feature1': 'Crea tu propia comunidad',
  'floatingButton.embassador.feature2': 'Gana hasta {maxLevels} niveles de comisiones',
  'floatingButton.embassador.feature3': 'Pagos puntuales, programados para el día 15 de cada mes',

};

export default homepage;
